// The landing route for each role, shared by the header menu, the Account page and VerifyPhone —
// previously duplicated in all three, which is how the `citizen` entry went missing (switching to
// Citizen fell through to /account, which RequireAuth bounced to a blank /verify-phone).
export const roleHome = {
  citizen: "/", // the city home — a citizen has no dedicated console
  business_owner: "/owner",
  // No "/worker": the web carries no worker-operational views (workers are Android-only),
  // so a worker signing in here lands on the city home rather than a route that 404s.
  worker: "/",
  operator: "/city-desk",
  platform_admin: "/platform",
};
